import { startsWith } from 'lodash'

export default function ({ app, redirect, route }) {
  // only run this middleware on the client side if they are logged in
  if (
    !app.$auth.$state.loggedIn ||
    app.$auth.$state.user.phoneVerificationVerified ||
    // Exit out if the user is a placeholder
    app.$auth.$state.user.isPlaceholder
  ) {
    return
  }

  // if they aren't on the sign-up or sign-out page and they aren't on the personal details page - redirect them
  if (!startsWith(route.path, '/sign') && !startsWith(route.path, '/my-kintell/my-details')) {
    redirect('/my-kintell/my-details')
  }
}
